import React, { Component } from "react";
import { Jumbotron, Grid, Tabs, Col, Tab } from 'react-bootstrap';
import { compose } from 'redux'
import { connect } from 'react-redux'
import {
  firebaseConnect,
  isLoaded
} from 'react-redux-firebase'
import _ from 'lodash'

import ProjectList from './ProjectList'
import { serviceTypeMap } from "./constants";
import './Home.css';

class Home extends Component {
  render() {
    if (!this.props.projects || !isLoaded(this.props.projects)) {
      return <div />;
    }
    return (
      <div>
        <Jumbotron className="bg text-center">
          <h1>&nbsp;<br/>&nbsp;</h1>
        </Jumbotron>
        <Grid className="project-box">
          <Col xs={12}>
            <Tabs defaultActiveKey="staging" id="projects-tabs">
            {
              Object.keys(serviceTypeMap).map((serviceType) => {
                let projects = _.pickBy(this.props.projects, (project, key) => {
                  return project.serviceType === serviceType
                })
                return (
                  <Tab key={serviceType} eventKey={serviceType} title={serviceTypeMap[serviceType]}>
                    <ProjectList projects={projects} />
                  </Tab>
                );
              })
            }
            </Tabs>
          </Col>
        </Grid>
      </div>
    );
  }
}

export default compose(
  firebaseConnect(['projects']),
  connect(
    ({ firebase }) => ({
      projects: firebase.data.projects,
    })
  )
)(Home)


// WEBPACK FOOTER //
// ./src/Home.js